import React, { FC, useCallback, useState } from "react"
import * as Yup from "yup"
import { Button, CircularProgress, Modal, TextField } from "@material-ui/core"
import { Formik } from "formik"
import { addUserBadge } from "../../../../actions"
import styles from "./styles.module.scss"
import { FormValues } from "./types"
import { User } from "../../../../types"

interface AddUserBadgeModalProps {
  listItem: User | null
  fetchData: () => void
  hideModal: () => void
}

export const AddUserBadgeModal: FC<AddUserBadgeModalProps> = ({ listItem, hideModal, fetchData }) => {
  const [errorModal, setErrorModal] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const handleClickAdd = useCallback(
    async (values: FormValues) => {
      if (!listItem?.id) return

      setIsLoading(true)

      const response = await addUserBadge(listItem.id, values.badge_id)

      if (response?.error) {
        setErrorMessage(response?.message || response?.error)
        handleOpenErrorModal()
      } else {
        await fetchData()
        hideModal()
      }

      setIsLoading(false)
    },
    [listItem, fetchData, hideModal],
  )

  const handleOpenErrorModal = () => setErrorModal(true)
  const handleCloseErrorModal = () => setErrorModal(false)

  return (
    <div className={styles.modalBody}>
      <h2>Grant Badge to {listItem?.username}</h2>
      <Modal className={styles.modal} open={errorModal} onClose={handleCloseErrorModal}>
        <div className={styles.errorModal}>
          <h2>{errorMessage}</h2>
        </div>
      </Modal>
      <Formik
        initialValues={{
          badge_id: "",
        }}
        onSubmit={handleClickAdd}
        validationSchema={Yup.object().shape({
          badge_id: Yup.string().required(),
        })}>
        {({ handleChange, handleSubmit, errors, values }) => (
          <>
            <TextField
              className={styles.modalInput}
              fullWidth
              required
              label="badge_id"
              onChange={handleChange("badge_id")}
              placeholder="badge_id"
              error={!!errors.badge_id}
              value={values.badge_id}
              disabled={isLoading}
            />

            <div className={styles.buttonContainer}>
              {isLoading ? (
                <CircularProgress size={30} />
              ) : (
                <Button variant="contained" size="small" onClick={() => handleSubmit()}>
                  Add
                </Button>
              )}
            </div>
          </>
        )}
      </Formik>
    </div>
  )
}
